import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Fragment, useEffect, useMemo, useState } from "react";
import FileAttach from "../../../../images/BrowseFiles.svg";
import DownArrow from "../../../../images/DownArrow.svg";
import TotalStudents from "../../../../images/TotalMale.svg";
import ReadyToImport from "../../../../images/Present.svg";
import ContainsError from "../../../../images/Absent.svg";
import ExcelJS from "exceljs";
import Info from "../../../../images/Information.svg";

import Close from "../../../../images/Close.svg";
import ReactModal from "react-modal";

import { useLazyQuery, useMutation } from "@apollo/client";

import * as XLSX from "xlsx";
import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
  YesNo,
} from "../../../../utils/Enum.types";
import useLabels from "../../../../customHooks/useLabels";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../utils/constants";
import useUrlParams from "../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { useNavigate } from "react-router-dom";
import { AddCompany } from "./queries/mutations";
import {
  AddCompanyResult,
  AddCompanyVar,
  AtsCompanyOrderField,
  ExportCompanyTemplateData,
  ExportCompanyTemplateVars,
} from "./queries/types";
import { getDownloadUrl } from "../../../../utils/DownloadFile";
import { ExportCompanyTemplate, GetCompanies } from "./queries/queries";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import {
  removeCompleteSpace,
  removeMoreSpace,
} from "../../../../utils/UtilFunctions";
import Navbar from "../../../common/layout/Navbar";
import { Title } from "../../../../stories/Title/Title";
import { CustomTooltip } from "../../../../styles/TooltipStyles";
import { Button } from "../../../../stories/Button/Button";
import {
  LoadingStyles,
  ViewPickedSubjectModalStyles,
} from "../../../../styles/ModalStyles";
import ExcelLoading from "../../../pages/ExcelLoading";
import MessageModal from "../../../../customComponents/MessageModal";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  NavType: LicenseTypes;
}
const ImportCompanies = ({ setModalFlag, NavType, pageType }: Props) => {
  const [records, setRecords] = useState<any[]>([]);

  const [stdConfig, setStdConfig] = useState(false);

  const [message, setMessage] = useState(emptyMessage);
  const { customer_id } = useUrlParams();
  const [importModal, setImportModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);

  const { user_details } = useLoggedInUserDetails();

  const { companyLabel } = useLabels();

  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);

  const [ImportCompany, { loading }] = useMutation<
    AddCompanyResult,
    AddCompanyVar
  >(AddCompany, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });
  const [ExportComp] = useLazyQuery<
    ExportCompanyTemplateData,
    ExportCompanyTemplateVars
  >(ExportCompanyTemplate, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const displayFileName = (): void => {
    const inputElement = document.getElementById("input") as HTMLInputElement;
    const fileName = inputElement.value;
    const fileLabel = document.getElementById("file-name") as HTMLSpanElement;
    fileLabel.innerHTML = fileName.split("\\").pop()!;
  };
  const handleExport = async () => {
    try {
      if (customer_id) {
        const { data, errors } = await ExportComp({
          variables: {
            customerID: customer_id,
          },
        });

        if (data && data.ExportCompanyTemplate) {
          const res = await getDownloadUrl(data.ExportCompanyTemplate, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        } else {
          setMessage({
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          });
        }

        if (errors && errors.length > 0) {
          setMessage({
            flag: true,
            message: errors[0].message,
            operation: Operation.NONE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };
  const totalRecords = useMemo(() => {
    return records.filter((record) => !record.errors).length;
  }, [records]);
  const downloadExcelContainsError = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("ErrorData");
    worksheet1.views = [{ state: "frozen", xSplit: 1, ySplit: 1 }];
    if (records.length === 0) {
      console.warn("No data available to create the Excel file.");
      return;
    }

    const errorColumns = ["errors"];
    const headers = Object.keys(records[0]).filter(
      (header) =>
        !["isChecked", "isValidated", "isValidatedAndError", "id"].includes(
          header
        )
    );

    errorColumns.forEach((col) => {
      if (!headers.includes(col)) {
        headers.push(col);
      }
    });
    worksheet1.columns = headers.map((header) => ({
      header,
      key: header,
      width: 20,
    }));

    const headerRow = worksheet1.getRow(1);
    headerRow.height = 25;
    headerRow.font = { name: "Arial", size: 12, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFE0B2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    records
      .filter((record) => record?.errors)
      .forEach((entry, rowIndex) => {
        const row = worksheet1.getRow(rowIndex + 2);
        headers.forEach((header, colIndex) => {
          const cell = row.getCell(colIndex + 1);
          cell.value = entry[header];
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "StudentInfo.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  const handleAddSubsidiarySite = async () => {
    setSuccessCount(0);
    setErrorCount(0);
    setImportModal(true);

    for (const record of records.filter((record) => !record.errors)) {
      try {
        await ImportCompany({
          variables: {
            customer_id: customer_id!,
            user_details,
            input: {
              address: removeMoreSpace(record.Address),
              contactPerson: removeMoreSpace(record.ContactPerson) || "",
              contactPersonDesign:
                removeMoreSpace(record.ContactPersonDesign) || "",
              contactPersonEmail:
                removeMoreSpace(record.ContactPersonEmail) || "",
              contactPersonMobile: record.ContactPersonMobile || "",
              country: record.Country || "",
              email: record.Email || "",
              enableGst: record.EnableGst
                ? record.EnableGst.toLocalLowerCase() === YesNo.YES
                : false,
              enableTcs: record.EnableTcs
                ? record.EnableTcs.toLocalLowerCase() === YesNo.YES
                : false,
              enableTds: record.EnableTds
                ? record.EnableTds.toLocalLowerCase() === YesNo.YES
                : false,
              gstNo: removeMoreSpace(record.GstNo) || "",
              latitude: record.Latitude,
              logoFilename: removeMoreSpace(record.LogoFilename) || "",
              longitude: record.Longitude,
              mobile: removeMoreSpace(record.Mobile) || "",
              name: removeMoreSpace(record[`${companyLabel}`]) || "",
              oth1No: removeMoreSpace(record.Oth1No) || "",
              oth2No: removeMoreSpace(record.Oth2No) || "",
              panNo: removeMoreSpace(record.PanNo) || "",
              pin: removeMoreSpace(record.Pin) || "",
              place: removeMoreSpace(record.Place) || "",
              regType: removeMoreSpace(record.RegType) || "",
              state: removeMoreSpace(record.State) || "",
              tanNo: removeMoreSpace(record.TanNo) || "",
              url: record.Url || "",
              vatNo: record.VatNo || "",
              icon: record.icon || "",
            },
          },
          refetchQueries: [
            {
              query: GetCompanies,
              variables: {
                after: null,
                customerID: customer_id,
                empID: user_details.id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsCompanyOrderField.NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setSuccessCount((prev) => prev + 1);
          }
        });
      } catch (error) {
        console.error(error);
        setErrorCount((prev) => prev + 1);
      }
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };
  const entity_schema = {
    [`${removeCompleteSpace(companyLabel)}`]: {
      Headers: `${companyLabel}`,
      key: [`${removeCompleteSpace(companyLabel)}`],
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    Address: {
      Headers: "Address",
      key: "Address",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Place: {
      Headers: "Place",
      key: "Place",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    State: {
      Headers: "State",
      key: "State",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Pin: {
      Headers: "PIN Code",
      key: "Pin",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Country: {
      Headers: "Country",
      key: "Country",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPerson: {
      Headers: "Contact Person",
      key: "ContactPerson",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPersonDesign: {
      Headers: "Contact Person Designation",
      key: "ContactPersonDesign",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPersonEmail: {
      Headers: "Contact Person Email",
      key: "ContactPersonEmail",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPersonMobile: {
      Headers: "Contact Person Mobile",
      key: "ContactPersonMobile",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Email: {
      Headers: "Email",
      key: "Email",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Mobile: {
      Headers: "Mobile",
      key: "Mobile",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Telephone: {
      Headers: "Telephone",
      key: "Telephone",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Url: {
      Headers: "URL",
      key: "Url",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    LogoFilename: {
      Headers: "Logo Filename",
      key: "LogoFilename",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    RegType: {
      Headers: "Registration Type",
      key: "RegType",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    GstState: {
      Headers: "GST State",
      key: "GstState",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    PanNo: {
      Headers: "PAN Number",
      key: "PanNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    GstNo: {
      Headers: "GST Number",
      key: "GstNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TanNo: {
      Headers: "TAN Number",
      key: "TanNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    VatNo: {
      Headers: "VAT Number",
      key: "VatNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Oth1No: {
      Headers: "Other Number 1",
      key: "Oth1No",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Oth2No: {
      Headers: "Other Number 2",
      key: "Oth2No",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Latitude: {
      Headers: "Latitude",
      key: "Latitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Longitude: {
      Headers: "Longitude",
      key: "Longitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
  };

  const processExcel = (data: any) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const firstSheet = workbook.SheetNames[0];
    const records = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
    records.forEach((record: any) => {
      let errors: any = [];

      Object.keys(entity_schema).forEach((key) => {
        // @ts-ignore
        let keySchema = entity_schema[key];
        let keyValue = record[key];

        if (
          keySchema?.required &&
          (keyValue === null || keyValue === undefined)
        ) {
          let errorObj = {
            column: key,
            error: "Required",
          };
          errors.push(errorObj);
        }
      });

      if (errors.length > 0) {
        record.errors = errors;
      }
    });

    return records;
  };

  useEffect(() => {
    const input = document.getElementById("input") as HTMLInputElement;
    if (input) {
      input.addEventListener("change", () => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const res = processExcel(reader.result);
          setRecords(
            res.map((f: any, index: number) => {
              return {
                ...f,
                id: index + 1,
                isChecked: false,
                isValidated: false,
                isValidatedAndError: false,
              };
            })
          );
        };
        reader.readAsBinaryString(input.files![0]);
      });
    }
  });

  const schemaKeys = Object.keys(entity_schema);

  return (
    <>
      {pageType === PageFor.GENERAL ? (
        <>
          <Navbar NavType={NavType} />
          <Title>Import {companyLabel} Details</Title>
        </>
      ) : null}
      <div
        className={`import-excel-data${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        {" "}
        {pageType === PageFor.MODAL && (
          <div className="import-excel-data--title">
            <Title>Import {companyLabel} Details</Title>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </div>
        )}
        <div className="row g-0 import-excel-data__blocks">
          <div className="col-6">
            <div className="import-excel-data__file-upload">
              <div className="import-excel-data__file-upload--file-name">
                <span id="file-name"></span>
              </div>
              <div className="import-excel-data__file-upload--browse">
                <label htmlFor="input">
                  <img src={FileAttach} alt="/" /> Choose Excel File
                </label>
                <input
                  id="input"
                  type="file"
                  name="file"
                  onChange={() => displayFileName()}
                  className="import-excel-data__file-upload--input"
                />
              </div>
            </div>
          </div>

          <div className="col import-excel-data__blocks--cards">
            <b>
              <img src={TotalStudents} alt="/" />
              Total {companyLabel}
            </b>
            <span className="import-excel-data__blocks--cards--total-students">
              {records.length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            // onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ReadyToImport} alt="/" />
              Ready to Import
            </b>
            <span className="import-excel-data__blocks--cards--ready-to-import">
              {records.filter((record) => !record.errors).length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ContainsError} alt="/" />
              Contains Error
            </b>
            <span className="import-excel-data__blocks--cards--contains-error">
              {records.filter((record) => record?.errors).length}
            </span>
          </div>
        </div>
        <div
          className={`import-excel-data__datablock${
            pageType === PageFor.MODAL ? "" : "--general"
          }`}
        >
          {records.length > 0 ? (
            <>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--records-count">
                  <span>
                    {records.filter((record) => !record.errors).length}
                  </span>
                  <b> Records Found to Import</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              <div className="import-excel-data__datablock--tableblock">
                <TableContainer className="import-excel-data__datablock--table">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell id="td-center">
                          {TableHeaders.SLNO}
                        </TableCell>
                        {schemaKeys
                          .filter((key) =>
                            records.some((record) => key in record)
                          )
                          .map((key, index) => (
                            <TableCell key={index}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {records
                        .filter((record) => !record?.errors)
                        .map((record, index) => (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            {schemaKeys
                              .filter((key) => key in record)
                              .map((key, colIndex) => (
                                <Fragment key={colIndex}>
                                  <TableCell key={colIndex}>
                                    {record[key]}
                                  </TableCell>
                                </Fragment>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--errors-count">
                  <span>{records.filter((d) => d?.errors).length}</span>
                  <b>Records Which Contains error(s)</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              {expanded && (
                <div className="import-excel-data__datablock--tableblock">
                  <TableContainer className="import-excel-data__datablock--table">
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="td-center">
                            {TableHeaders.SLNO}
                          </TableCell>

                          {schemaKeys
                            .filter((key) =>
                              records.some((record) => key in record)
                            )
                            .map((key, index) => (
                              <TableCell key={index}>{key}</TableCell>
                            ))}
                          <TableCell id="td-center">Error Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {records
                          .filter((record) => record?.errors)
                          .map((record, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell id="td-center">
                                  {index + 1}
                                </TableCell>
                                {schemaKeys
                                  .filter((key) => key in record)
                                  .map((key, colIndex) => (
                                    <Fragment key={colIndex}>
                                      <TableCell>{record[key]}</TableCell>
                                    </Fragment>
                                  ))}

                                <TableCell className="import-excel-data__datablock--error">
                                  <CustomTooltip
                                    title={
                                      <ul>
                                        {record?.errors
                                          ? record?.errors?.map(
                                              (error: any, index: number) => {
                                                return (
                                                  <li key={index}>
                                                    {index + 1})&nbsp;
                                                    {typeof error === "string"
                                                      ? error
                                                      : "Error message = " +
                                                        error.error +
                                                        ", column = " +
                                                        error.column}
                                                  </li>
                                                );
                                              }
                                            )
                                          : null}
                                      </ul>
                                    }
                                    arrow
                                    placement="bottom-start"
                                  >
                                    <div className="import-excel-data__datablock--tableblock--error-message">
                                      <span>Errors</span>
                                      <img src={Info} alt="/" />
                                    </div>
                                  </CustomTooltip>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              onClick={() => {
                handleAddSubsidiarySite();
              }}
              disabled={!records.length ? true : false}
              mode="excel"
            >
              Import
            </Button>
            <Button onClick={downloadExcelContainsError} mode="excel">
              Export error Data
            </Button>
            <Button
              mode={pageType === PageFor.GENERAL ? "back" : "cancel"}
              onClick={() => {
                if (pageType === PageFor.MODAL) {
                  setModalFlag(false);
                } else {
                  navigate(-1);
                }
              }}
            />
          </div>
          <div className="col-3 import-excel-data__button">
            <Button mode="excel" onClick={handleExport}>
              Generate Template XLS File
            </Button>
          </div>
        </div>
      </div>

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={importModal}
        style={LoadingStyles}
        ariaHideApp={false}
        onRequestClose={() => setImportModal(!importModal)}
      >
        <ExcelLoading
          total={totalRecords}
          success={successCount}
          errors={errorCount}
          loading={loading}
          setModalFlag={setImportModal}
        />
      </ReactModal>
      {/* <LoadingModal flag={AddItemLoading} /> */}
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={stdConfig}
        style={ViewPickedSubjectModalStyles}
        ariaHideApp={false}
      >
        <div className="import-excel-data__receipts">
          <div className="import-excel-data__receipts--title">
            <Title>Choose Properties</Title>
            <img
              src={Close}
              alt="/"
              className="modal-close-icon"
              onClick={() => setStdConfig(!stdConfig)}
            />
          </div>

          {/* <Button mode="excel" onClick={handleExport}>
                Download To Excel
              </Button> */}

          <Button mode="cancel" onClick={() => setStdConfig(!stdConfig)} />
        </div>
      </ReactModal>
    </>
  );
};

export default ImportCompanies;
